interface CardTitleProps {
  title: string;
  count?: number;
}

export const CardTitle: React.FC<CardTitleProps> = ({ title, count }) => {
  return (
    <h3 className="font-bold mt-3 text-3xl mb-6">
      {title}{" "}
      {count !== undefined && <span className="text-2xl">({count})</span>}
    </h3>
  );
};
